module.exports = __webpack_public_path__ + "img/enemy_122_001.44d6a494.png";